export function isImageResource(resource) {
    return resource.type === "IMAGE";
}
